import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';

const [
  LIST_PROJECT_TAXBILLS,
  LIST_PROJECT_TAXBILLS_SUCCESS,
  LIST_PROJECT_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_TAXBILLS');

export const listProjectTaxbills = createAction(
  LIST_PROJECT_TAXBILLS,
  (id) => id,
);
const listProjectTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_TAXBILLS,
  taxbillApi.getTaxbillsByPrj,
);

const UNLOAD_TAXBILLS = 'project/UNLOAD_TAXBILLS';
export const unloadTaxbills = createAction(UNLOAD_TAXBILLS);

export function* projectTaxbillsSaga() {
  yield takeLatest(LIST_PROJECT_TAXBILLS, listProjectTaxbillsSaga);
}

const initialState = {
  taxbills: null,
  error: null,
};

const projectTaxbills = handleActions(
  {
    [LIST_PROJECT_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      taxbills: data.list.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        billTyp: inv.billTyp,
        cstNm: inv.cstNm,
        partnerNm: inv.partnerNm,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        reqPlanDt: inv.reqPlanDt,
        reqPlanYn: inv.reqPlanYn,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanUsrNm: inv.reqPlanUsrNm,
        reqPlanTxt: inv.reqPlanTxt,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompUsrNm: inv.reqCompUsrNm,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsrNm: inv.procPlanUsrNm,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtGradeNm: inv.crtGradeNm,
        crtDptNm: inv.crtDptNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TAXBILLS]: () => initialState,
  },
  initialState,
);

export default projectTaxbills;
